var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditScoreSvg = function SvgCreditScoreSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h32c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4",
    style: {
      fill: "#f2f7ff"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "CreditScoreSVG_svg__a",
    d: "M6 6h28v28H6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "CreditScoreSVG_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CreditScoreSVG_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#CreditScoreSVG_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 34c7.7 0 14-6.3 14-14S27.7 6 20 6 6 12.3 6 20s6.3 14 14 14",
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "CreditScoreSVG_svg__c",
    cx: -943.716,
    cy: 1028.9,
    r: 1,
    gradientTransform: "matrix(-23.6425 19.0186 17.2754 21.4756 -40054.648 -4140.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9dc2ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3d7feb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.1 13C29.6 8.7 25 6 20 6v3.9h.6c3.4.2 6.5 2.1 8.2 5.1 1.7 2.9 1.8 6.3.4 9.3-.2.5 0 1 .4 1.3l2.5 1.5c1.2-2.1 1.9-4.5 1.9-7 0-2.6-.6-5-1.9-7.1M20 9.9V6c-5 0-9.6 2.7-12.1 7s-2.5 9.7 0 14l2.5-1.5c.4-.3.6-.8.4-1.3-1.4-3-1.2-6.5.4-9.3 1.8-3.1 5.2-5 8.8-5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#CreditScoreSVG_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "CreditScoreSVG_svg__d",
    cx: -933.536,
    cy: 1058.734,
    r: 1,
    gradientTransform: "matrix(-12.4478 14.588 12.9547 11.0542 -25309.045 1926.337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe0b9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#cd9a58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.5 22.6 2.5-8c.1-.3-.2-.6-.5-.5l-8 2.5c-3.5 1.1-4.6 5.5-2 8.1 2.5 2.5 6.9 1.4 8-2.1",
    style: {
      fill: "url(#CreditScoreSVG_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 19.7c-.8-.8-2.1-.8-2.9 0s-.8 2.1 0 2.9 2.1.8 2.9 0c.8-.7.8-2.1 0-2.9",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgCreditScoreSvg;